import React, { useContext, useEffect, useState } from "react";
import { GAME_STAGES, DEFAULT_ROOM, HOME_PATH } from "../../constants/gameStages";
import { Link, useNavigate } from "react-router-dom";
import WaitingButton from "../../components/WaitingButton";
import { SocketContext } from "../../context/SocketProvider";
import { PausedOverlay } from "../../components";
import { useGameStage } from "../../hooks/useGameStage";
import { useRoleBackground } from "../../hooks/useRoleBackground";
import { useLanguage } from "../../context/LanguageContext";
import hint1 from "../../assets/hint1.png";
import hint1_jp from "../../assets/hint1_jp.png";

function WaitingForGuesser({ gameStage }) {
  const navigate = useNavigate();
  const { bgStyle, className } = useRoleBackground("pink");
  const { t, language } = useLanguage();

  useEffect(() => {
    if (gameStage === GAME_STAGES.RESULTS) {
      navigate("/aiwaiting", { replace: true });
    }
  }, [gameStage, navigate]);

  const destination =
    gameStage === GAME_STAGES.RESULTS ? "/seeresults" : "/waitingforguesser";

  const [canProceed] = useState(false);
  const { showPausedOverlay, setShowPausedOverlay } = useContext(SocketContext);
  const { updateStage } = useGameStage();

  // Select appropriate hint image based on language
  const hintImage = language === 'ja' ? hint1_jp : hint1;

  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dotString = ".".repeat(dotCount);

  return (
    <div className={className} style={bgStyle}>
      <div className="min-h-screen flex flex-col text-center items-center">
        <h1 className="text-[40px] font-bold text-black mt-[128px] mb-[32px]">
          {t('describer.waiting', 'Waiting for Guesser to select an image')}
          <span className="inline-block w-12 text-left">{dotString}</span>
        </h1>
        <div className="mb-[64px]">
          {canProceed ? (
            <WaitingButton
              proceed={true}
              destination={destination}
              nextMsg={t('button.continue', 'Continue!')}
              nextClassName="btn-pink-lg"
              className="btn-pink-lg"
            />
          ) : (
            <button className="btn-pink-lg" disabled={true}>
              {t('button.continue', 'Continue!')}
            </button>
          )}
        </div>
        <img src={hintImage} alt="hints" className="absolute bottom-0" />

        {/* <ConfirmReturnButton modal={false} /> */}
      </div>
      
      {showPausedOverlay && (
        <PausedOverlay
          onReload={() => {
            updateStage(GAME_STAGES.WAITING);
            setShowPausedOverlay(false);
            navigate(HOME_PATH);
          }}
        />
      )}
    </div>
  );
}

export default WaitingForGuesser;
